import { useCallback, useContext, useEffect, useState } from "react";
import { authorOption, robotsOption, statusOption } from "../../../constant";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const usePost = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "post");
  const { setTitle } = useService("Meta");
  const { isEmpty } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [, setactiveRobotsIndex] = useState<number>(0);
  const [, setactiveStatusIndex] = useState<number>(0);
  const [, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState<string>("[]");
  const [, setuid] = useState<string>("");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState<string>("");
  const [, setexcerpt] = useState<string>("");
  const [, setcss] = useState<string>("");
  const [, setjs] = useState<string>("");
  const [, setcanonical] = useState<string>("");
  const [, setrobots] = useState<string>("");
  const [, setmetaDescription] = useState<string>("");
  const [, setmetaKeyword] = useState(null);
  const [, setauthor] = useState<string>("");
  const [publishDate, setpublishDate] = useState(new Date());
  const [, setstatus] = useState(null);
  const [category, setcategory] = useState([]);
  const [, settag] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const getPostData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      if (result.data[0].status !== "publish")
        navigateTo({ route: "/error404" });
      else {
        const postData = result.data[0];
        setactiveAuthorIndex(
          authorOption.findIndex((e) => e.value === postData.robots)
        );
        setactiveRobotsIndex(
          robotsOption.findIndex((e) => e.value === postData.robots)
        );
        setactiveStatusIndex(
          statusOption.findIndex((e) => e.value === postData.status)
        );
        settag(isEmpty(postData.tag) ? [] : JSON.parse(postData.tag));
        setcategory(
          isEmpty(postData.category) ? [] : JSON.parse(postData.category)
        );
        setmetaKeyword(
          isEmpty(postData.metaKeyword) ? [] : JSON.parse(postData.metaKeyword)
        );
        setTitle(postData.title);
        settitle(postData.title);
        setslug(postData.slug);
        setcontent(postData.content);
        setexcerpt(postData.excerpt);
        setcss(postData.css);
        setjs(postData.js);
        setcanonical(postData.canonical);
        setrobots(postData.robots);
        setmetaDescription(postData.metaDescription);
        setauthor(postData.author);
        setpublishDate(new Date(postData.publishDate));
        setstatus(postData.status);
        setuid(postData.uid);
        setimage(postData.image);
      }
    }
  }, [fetchByAttr, isEmpty, navigateTo, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getPostData({ slug: urlSlug });
  }, [slug, urlSlug, getPostData]);
  return {
    category: category.join(", "),
    title,
    publishDate,
    image,
    content,
    slug,
  };
};
